export default __webpack_public_path__ + "static/media/master_card.80ba1409.svg";